const OBSROOT = "https://cdn.landcloud.org.cn"; //  https://cdn.landcloud.org.cn   https://obs-gtdcy3.obs.cn-north-1.myhuaweicloud.com

window.CONFIG = {
  dyPlayUrl: "https://v.douyin.com/yJ1tfhL/",
  bucketList: ["gtdcy-obs", "obs-gtdcy3", "obs-cq-workplatform", "obs-cq-workplatform-ktd"],
  ttUrl: "https://www.toutiao.com/c/user/token/MS4wLjABAAAAcEJDWf0PlkRJzC1KpUR0wKEDConGLG-FFHE7eSy79A8?wid=1687768826743",
  version: "zhengshi",
  debug: true,
  wsOpen: false,
  taskTemplateUseJA: false,
  baseMapLayer: [
    // 本地key 78d442b17fd42f9e9b352580511c6e62
    // 天地图key   4e61c54af3a524244ebce24178965444  ec7fe0feda91baac20f7835cfdce24c5 ffa5ef8e4ea43caf693fa0097f8258a6 73df71de2ef41ac03323a12aa5b0c7dd  93724b915d1898d946ca7dc7b765dda5
    {
      name: "天地图影像底图",
      url: "http://t{s}.tianditu.gov.cn/DataServer?T=img_c&X={x}&Y={y}&L={z}&tk=78d442b17fd42f9e9b352580511c6e62",
      able: true,
      options: {
        subdomains: ["0", "1", "2", "3", "4"],
      },
    },
    {
      name: "天地图底图注记",
      url: "http://t{s}.tianditu.gov.cn/DataServer?T=cia_c&X={x}&Y={y}&L={z}&tk=78d442b17fd42f9e9b352580511c6e62",
      able: true,
      options: {
        subdomains: ["0", "1", "2", "3", "4"],
      },
    },
    {
      name: "天地图政区边界",
      url: "http://t{s}.tianditu.gov.cn/DataServer?T=ibo_c&X={x}&Y={y}&L={z}&tk=78d442b17fd42f9e9b352580511c6e62",
      able: true,
      options: {
        subdomains: ["0", "1", "2", "3", "4"],
      },
    },
    {
      name: "矢量底图",
      url: "http://t{s}.tianditu.gov.cn/DataServer?T=vec_c&X={x}&Y={y}&L={z}&tk=78d442b17fd42f9e9b352580511c6e62",
      able: true,
      options: {
        subdomains: ["0", "1", "2", "3", "4"],
      },
    },
    {
      name: "矢量注记",
      url: "http://t{s}.tianditu.gov.cn/DataServer?T=cva_c&X={x}&Y={y}&L={z}&tk=78d442b17fd42f9e9b352580511c6e62",
      able: true,
      options: {
        subdomains: ["0", "1", "2", "3", "4"],
      },
    },
  ],
  wsUrl: "wss://beta.landcloud.org.cn:8083/instant/gen",
  // 机器人的配置，进入项目要初始化 ↓
  robot: {
    code: "hd961ic",
    link: "https://guotu.s4.udesk.cn/im_client/?web_plugin_id=16728",
  },
  publicTheme: {
    path: OBSROOT + "/public/gzpt/theme/",
    type: "blue",
  },
  regionRoot: {
    code: "1",
  },
  workringUrl: "https://www.landcloud.org.cn/workring/#/",
  // workringUrl: 'http://localhost:8080/#/',
  minbuffer: 100,
  apmAppId: "4a26d65d819e43a68cc4705ef486b786", //apm的appId，用于华为应用性能监控
  cdnImageUrl: "https://cdn.landcloud.org.cn/public/gzpt/images/",
  dataCenter: { bucket: "obs-gtdcy3" },
  timePhaseUrl: "https://dd.landcloud.org.cn",
  UNITCODELIST: [{ code: "5ADD829238AC4F1FA5FA1A15B0C208A1", name: "广东省国土资源测绘院" }],
  localMapKey: "78d442b17fd42f9e9b352580511c6e62",

  CloudImageBaseUrl: "cdn.landcloud.org.cn",
};
